import React, { Component } from 'react';
import {connect} from 'react-redux';
import RaceConfigForm from './race-config-form'


class RaceConfig extends Component {


	constructor(props){
		super(props);
		this.state = { name: "", value: '', today: new Date().toISOString().substring(0, 10)} 
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	
	handleChange(event) {
	    this.setState({value: event.target.value});
	}

	handleSubmit(event) {
    	//alert('A name was submitted: ' + this.state.value);
    	event.preventDefault();
		console.log("handleOnPrint");


		//const input = window.document.getElementById('divToPDF');
		window.print();
		// Default export is a4 paper, portrait, using milimeters for units
  	}


	render(){
		return (
			<div >
				<RaceConfigForm />
			</div>
	 	);
	}
}



/**
				
				    <FormGroup >
				      <Col componentClass={ControlLabel} sm={2}>
				        Hora Inicio:
				      </Col>
				      <Col sm={10}>
				    	<FormControl type="text" value={this.getTime(this.props.startedAt)} />
				      </Col>
				    </FormGroup>

				    <FormGroup >
				      <Col componentClass={ControlLabel} sm={2}>
				        Hora Fin:
				      </Col>
				      <Col sm={10}>
				    	<FormControl type="text" value={this.getTime(this.props.stoppedAt)} />
				      </Col>
				    </FormGroup>

				    <FormGroup >
				      <Col componentClass={ControlLabel} sm={2}>
				        Tiempo Total:
				      </Col>
				      <Col sm={10}>
				    	<FormControl type="text" value={this.getTotalTime(this.props.startedAt, this.props.stoppedAt)}/>
				      </Col>
				    </FormGroup>

				    <FormGroup >
				      <Col componentClass={ControlLabel} sm={2}>
				        Participantes:
				      </Col>
				      <Col sm={10}>
				    	<Badge>{this.getTotalParticipantes()}</Badge>
				      </Col>
				    </FormGroup>

				    <FormGroup >
				      <Col componentClass={ControlLabel} sm={2}>
				        Hombres:
				      </Col>
				      <Col sm={10}>
				    	<Badge>{this.getTotalHombres()}</Badge>
				      </Col>
				    </FormGroup>

				    <FormGroup >
				      <Col componentClass={ControlLabel} sm={2}>
				        Mujeres:
				      </Col>
				      <Col sm={10}>
				    	<Badge>{this.getTotalMujeres()}</Badge>
				      </Col>
				    </FormGroup>

				    <FormGroup >
				      <Col componentClass={ControlLabel} sm={2}>
				        Especiales:
				      </Col>
				      <Col sm={10}>
				    	<Badge>{this.getTotalEspecial()}</Badge>
				      </Col>
				    </FormGroup>

*/

function mapStateToProps(state) {
  const { participantList } = state.reducerRegisterTime;
  const { startedAt, stoppedAt } = state.reducerTimer;
  return { participantList, startedAt, stoppedAt };
}

export default connect(mapStateToProps)(RaceConfig);




// WEBPACK FOOTER //
// ./src/containers/race-config.js